import { render, staticRenderFns } from "./AlarmTypesSelect.vue?vue&type=template&id=0f0afbc4"
import script from "./AlarmTypesSelect.vue?vue&type=script&lang=js"
export * from "./AlarmTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports